/** Site-wide constants — the only place addresses and external links are written. */
export const SITE = {
  company: 'FNK Labs',
  product: 'Fnk',
  sales: 'sales@fnk.ai',
  investors: 'investors@fnk.ai',
  salesMailto: 'mailto:sales@fnk.ai',
  assessmentMailto: 'mailto:sales@fnk.ai?subject=Efficiency%20assessment%20enquiry',
  dialogme: 'https://dialogme.ai',
} as const;
